import { senders } from './dropdownOptions';
import { getLocalDateTimeString } from './localDateTime';

const defaultShipper = senders[0];

export const initialFormData = {
    orderNum: '',
    replaceNumPackagesValue: false,
    requestPdfLabels: false,
    // Recipient information
    includeReturnLabel: false,
    isReturnOnly: false,
    country: 'US',
    contactName: '',
    companyName: '',
    address1: '',
    address2: '',
    address3: '',
    postalCode: '',
    stateProvince: '',
    city: '',
    telephone: '',
    email: '',
    ext: '',
    taxIdType: 'EIN',
    taxId: '',
    residentialAddress: false,
    // Sender information
    shipper: defaultShipper.id,
    shipperName: defaultShipper.contactName,
    shipperTelephone: defaultShipper.telephone,
    shipperEmail: defaultShipper.email,
    shipperCountry: defaultShipper.country,
    shipperAddress1: defaultShipper.address1,
    shipperAddress2: defaultShipper.address2,
    shipperCity: defaultShipper.city,
    shipperState: defaultShipper.state,
    shipperPostalCode: defaultShipper.postalCode,
    shipperCompany: defaultShipper.companyName,
    shipperResidentialAddress: defaultShipper.residential,
    // Package and shipment details
    packageContains: 'commodity',
    numPackages: 1,
    identicalPackages: false,
    weight: '',
    weightUnit: 'LB',
    serviceType: '',
    indicia: 'PARCEL_SELECT',
    packageType: '',
    subPackagingType: '',
    length: '',
    width: '',
    height: '',
    dimensionsUnit: 'IN',
    packageDescription: '',
    shipDate: getLocalDateTimeString().slice(0, 10),
    declaredValue: '',
    declaredValueCurrency: 'USD',
    totalCustomsValue: '',
    totalCustomsValueCurrency: '',
    // Billing details
    billTransportationTo: 'SENDER',
    accountNum: process.env.REACT_APP_ACCOUNT_NUM,
    senderAccountNum: process.env.REACT_APP_ACCOUNT_NUM,
    departmentNotesCode: '',
    departmentNotesName: '',
    customerReference: '',
    poNum: '',
    // Additional references
    invoiceNum: '',
    deliveryInstructions: '',
    // Special Services
    specialServices: [],
    // Commodities
    commodities: [],
    // Signature options
    signatureOption: 'SERVICE_DEFAULT',
    // ShipAlert
    shipAlerts: {
        sender: {
            emailNotificationRecipientType: 'SHIPPER',
            notificationFormatType: 'TEXT',
            emailAddress: defaultShipper.email,
            notificationEventType: ['ON_EXCEPTION']
        },
        recipient: {
            emailNotificationRecipientType: 'RECIPIENT',
            notificationFormatType: 'TEXT',
            emailAddress: '',
            notificationEventType: []
        },
        broker: {
            emailNotificationRecipientType: 'BROKER',
            notificationFormatType: 'TEXT',
            emailAddress: '',
            notificationEventType: []
        },
        other1: {
            emailNotificationRecipientType: 'OTHER',
            notificationFormatType: 'TEXT',
            emailAddress: '',
            notificationEventType: []
        },
        other2: {
            emailNotificationRecipientType: 'OTHER',
            notificationFormatType: 'TEXT',
            emailAddress: '',
            notificationEventType: []
        },
    },
    personalMessage: '',
    // MPS
    mpsPackages: [],
    // Customs
    shipmentPurpose: 'SOLD',
    electronicallyUploadTradeDocs: false,
    includeCommercialInvoicePf: false,
    commercialInvoicePfSource: '',
    insertLetterheadImg: false,
    insertSignatureImg: true,
    useDefaultSignatureImg: true,
    includeCertOfOrigin: false,
    certOfOriginSource: '',
    includeEei: false,
    eeiSource: '',
    ftrExemption: '',
    commercialInvoice: null,
    letterheadImg: null,
    signatureImg: null,
    certOfOrigin: null,
    sameAsConsignee: true,
    airWaybillNum: '',
    consigneeTaxIdType: 'EIN',
    consigneeTaxId: '',
    soldToTaxIdType: 'EIN',
    soldToTaxId: '',
    soldToCountry: '',
    soldToCompanyName: '',
    soldToAddress1: '',
    soldToAddress2: '',
    soldToAddress3: '',
    soldToPostalCode: '',
    soldToState: '',
    soldToCity: '',
    returnData: {
        // Returns - could move these to their actual form sections...
        returnLabelType: '',
        emailLabelTo: '',
        emailReturnMessage: '',
        emailReturnExpirationDate: '',
        rmaNum: '',
        linkToOutbound: false,
        returnInstructions: false,
        additionalInstructions: '',
        readyPickupDateTime: '',
        latestPickupDateTime: '',
        // // Recipient information
        country: 'US',
        contactName: '',
        companyName: '',
        address1: '',
        address2: '',
        postalCode: '',
        stateProvince: '',
        city: '',
        telephone: '',
        ext: '',
        residentialAddress: false,
        // Sender information
        shipper: defaultShipper.id,
        shipperName: defaultShipper.contactName,
        shipperTelephone: defaultShipper.telephone,
        shipperEmail: defaultShipper.email,
        shipperCountry: defaultShipper.country,
        shipperAddress1: defaultShipper.address1,
        shipperAddress2: defaultShipper.address2,
        shipperCity: defaultShipper.city,
        shipperState: defaultShipper.state,
        shipperPostalCode: defaultShipper.postalCode,
        shipperCompany: defaultShipper.companyName,
        shipperResidentialAddress: defaultShipper.residential,
        // Package and shipment details
        packageContains: 'commodity',
        numPackages: 1,
        identicalPackages: false,
        weight: '',
        weightUnit: 'LB',
        serviceType: '',
        indicia: 'PARCEL_SELECT',
        packageType: '',
        subPackagingType: '',
        length: '',
        width: '',
        height: '',
        dimensionsUnit: 'IN',
        packageDescription: '',
        shipDate: getLocalDateTimeString().slice(0, 10),
        declaredValue: '',
        declaredValueCurrency: 'USD',
        totalCustomsValue: '',
        totalCustomsValueCurrency: '',
        // Billing details
        billTransportationTo: 'SENDER',
        accountNum: process.env.REACT_APP_ACCOUNT_NUM,
        senderAccountNum: process.env.REACT_APP_ACCOUNT_NUM,
        departmentNotesCode: '',
        departmentNotesName: '',
        customerReference: '',
        poNum: '',
        // Additional references
        invoiceNum: '',
        deliveryInstructions: '',
        // Special Services
        specialServices: [],
        // Commodities
        commodities: [],
        // Signature options
        signatureOption: 'SERVICE_DEFAULT',
        // ShipAlert
        shipAlerts: {
            sender: {
                emailNotificationRecipientType: 'SHIPPER',
                notificationFormatType: 'TEXT',
                emailAddress: defaultShipper.email,
                notificationEventType: ['ON_EXCEPTION']
            },
            recipient: {
                emailNotificationRecipientType: 'RECIPIENT',
                notificationFormatType: 'TEXT',
                emailAddress: '',
                notificationEventType: []
            },
            broker: {
                emailNotificationRecipientType: 'BROKER',
                notificationFormatType: 'TEXT',
                emailAddress: '',
                notificationEventType: []
            },
            other1: {
                emailNotificationRecipientType: 'OTHER',
                notificationFormatType: 'TEXT',
                emailAddress: '',
                notificationEventType: []
            },
            other2: {
                emailNotificationRecipientType: 'OTHER',
                notificationFormatType: 'TEXT',
                emailAddress: '',
                notificationEventType: []
            },
        },
        personalMessage: '',
        // MPS
        mpsPackages: [],
        // Customs
        shipmentPurpose: 'SOLD',
        electronicallyUploadTradeDocs: true,
        includeCommercialInvoicePf: false,
        commercialInvoicePfSource: '',
        insertLetterheadImg: false,
        insertSignatureImg: true,
        useDefaultSignatureImg: true,
        includeCertOfOrigin: false,
        certOfOriginSource: '',
        includeEei: false,
        eeiSource: '',
        ftrExemption: '',
        commercialInvoice: null,
        letterheadImg: null,
        signatureImg: null,
        certOfOrigin: null,
        sameAsConsignee: true,
        // check all these extra fields and modify the form if you need to as well
        airWaybillNum: '',
        consigneeTaxIdType: 'EIN',
        consigneeTaxId: '',
        soldToTaxIdType: 'EIN',
        soldToTaxId: '',
        soldToCountry: '',
        soldToCompanyName: '',
        soldToAddress1: '',
        soldToAddress2: '',
        soldToAddress3: '',
        soldToPostalCode: '',
        soldToState: '',
        soldToCity: '',
    }
}
